import { Link } from 'react-router-dom';
import { homeStats } from '@/mocks/siteData';

const tickerItems = [
  '在线收信通道运行正常',
  '本期追踪：招标评审记录与公示内容出入',
  '线索邮箱 24 小时内完成首次查看',
  '公开信源泄露事件 0 次',
  '投稿、咨询、账号核实均不收取任何费用',
];

export default function Hero() {
  return (
    <section className="relative bg-foreground-950 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=dramatic%20dark%20editorial%20scene%20of%20an%20abstract%20ink%20blot%20spreading%20over%20a%20shadowy%20city%20skyline%20silhouette%2C%20crimson%20light%20streaks%20cutting%20through%20darkness%2C%20moody%20investigative%20journalism%20atmosphere%2C%20high%20contrast%2C%20cinematic%20grain%2C%20no%20text&width=1800&height=1100&seq=st-hero-2026&orientation=landscape"
          alt="抽象的墨迹与城市剪影构成的深色编辑室氛围背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/85 via-foreground-950/70 to-foreground-950/95"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950 via-foreground-950/60 to-transparent"></div>
      </div>

      <div className="relative z-10 w-full px-5 md:px-8 lg:px-12 pt-32 md:pt-44 pb-14 md:pb-20">
        <div className="max-w-[1400px] mx-auto animate-fade-up">
          <div className="flex items-center gap-3 font-mono text-[11px] md:text-xs tracking-[0.3em] uppercase text-accent-400">
            <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
            爆料官网 · 官方联系与投稿中心
          </div>

          <h1 className="mt-7 font-heading font-black text-background-50 leading-[1.06] text-4xl md:text-6xl lg:text-7xl max-w-4xl">
            深瞳爆料
            <span className="block mt-4 text-2xl md:text-4xl lg:text-[2.75rem] text-accent-400">
              让沉默的真相被听见
            </span>
          </h1>

          <p className="mt-7 max-w-2xl text-sm md:text-base leading-relaxed text-background-200">
            这里是深瞳爆料的官方联系中心。你可以在此找到经过官方确认的投稿邮箱、即时联络方式与商务合作渠道，
            并直接提交一条线索。我们以信源保护为第一原则，任何一条信息都会按保密规范处理。
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-3">
            <Link
              to="/contact"
              className="inline-flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium px-7 py-4 rounded-md transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-send-plane-line"></i>
              提交爆料线索
            </Link>
            <a
              href="#channels"
              className="inline-flex items-center justify-center gap-2 border border-background-50/35 hover:border-accent-400 hover:text-accent-300 text-background-50 text-sm font-medium px-7 py-4 rounded-md transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-contacts-book-2-line"></i>
              查看官方联系渠道
            </a>
          </div>

          <dl className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 border-t border-background-50/15 pt-8">
            {homeStats.map((stat) => (
              <div key={stat.label}>
                <dt className="font-heading text-2xl md:text-3xl font-bold text-background-50">
                  {stat.value}
                  <span className="text-base md:text-lg text-accent-400 ml-1">{stat.suffix}</span>
                </dt>
                <dd className="mt-2 font-mono text-[11px] md:text-xs text-background-300 leading-relaxed">
                  {stat.label}
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>

      <div className="relative z-10 overflow-hidden bg-primary-500 py-2.5">
        <div className="news-ticker-track animate-ticker">
          {[0, 1].map((dup) => (
            <div key={dup} className="flex items-center shrink-0">
              {tickerItems.map((item) => (
                <span
                  key={`${dup}-${item}`}
                  className="flex items-center gap-3 px-6 font-mono text-xs text-background-50 whitespace-nowrap"
                >
                  <i className="ri-record-circle-line text-[10px] text-background-50/70"></i>
                  {item}
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}